import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useNavigation } from '../../../../navigation/NavigationProvider';
import { useAuthTheme } from '../../hooks/useAuthTheme';
import { Button } from '../../../../core/design-system/components/Button';
import { Text } from '../../../../core/design-system/components/Text';
import GoogleAuthButton from '../buttons/GoogleAuthButton/index';
// AppleAuthButton retiré pour beta GPT Store (RAS-41)
import { Logo } from '../../../../core/design-system/components/Logo';
import { Icon } from '../../../../core/design-system/components/Icon';
import './styles.css';
import { Footer } from '../../../../shared/components/Footer';

const AuthHome = () => {
  const { openSignIn, openSignUp } = useNavigation();
  const { t } = useTranslation('auth');
  const location = useLocation();
  useAuthTheme();

  // Ouvrir automatiquement le modal signup/signin si ?modal=signup|signin (RAS-41)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const modal = params.get('modal');
    if (modal === 'signup') {
      openSignUp();
    } else if (modal === 'signin') {
      openSignIn();
    }
  }, [location.search, openSignIn, openSignUp]);

  const features = [
    { icon: 'map-pin', text: t('features.location') },
    { icon: 'bell', text: t('features.alerts') },
    { icon: 'running', text: t('features.running') },
    { icon: 'bike', text: t('features.biking') },
    { icon: 'calendar', text: t('features.events') },
    { icon: 'users', text: t('features.community') }
  ];

  return (
    <>
      <div className="main-content">
        <div className="auth-navbar">
          <div className="navbar-container">
            <div className="navbar-logo">
              <Logo size={32} />
            </div>
          </div>
        </div>
        <div className="home-container">
          <div className="left-section">
            <div className="main-logo-container desktop-only">
              <div className="logo-wrapper">
                <svg width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="main-logo-icon">
                  <path d="M50 5L15 55h35l-5 40 40-50h-35l5-40z" fill="#4096fb" />
                </svg>
                <span className="main-logo-text">RASKMOTE</span>
              </div>
              <span className="logo-subtitle">{t('home.logo_subtitle')}</span>
            </div>
            <div className="features-card">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <Icon 
                    name={feature.icon} 
                    size={24} 
                    color="var(--color-primary)" 
                    className="feature-icon"
                  />
                  <span className="feature-text">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="right-section">
            <div className="main-logo-container mobile-only">
              <svg width="80" height="80" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="main-logo-icon">
                <path d="M50 5L15 55h35l-5 40 40-50h-35l5-40z" fill="#4096fb" />
              </svg>
              <span className="main-logo-text">RASKMOTE</span>
            </div>
            
            <div className="title-section">
              <h1 className="hero-title">{t('home.hero.title')}</h1>
              <p className="hero-subtitle">{t('home.hero.subtitle')}</p>
            </div>
            
            <div className="auth-buttons">
              <GoogleAuthButton text={t('social.google')} />
              <div className="divider">{t('home.divider')}</div>
              <Button 
                type="button" 
                variant="primary"
                size="lg"
                fullWidth
                onClick={openSignUp}
              >
                {t('home.create_account')}
              </Button>
              
              <Text variant="body2" className="terms">
                {t('home.terms')}
              </Text>
            </div>
            
            <div className="signin-section">
              <Text variant="h3" className="signin-title">{t('home.signin_section.title')}</Text>
              <Button 
                variant="outline-primary"
                size="lg"
                fullWidth
                onClick={openSignIn}
              >
                {t('home.signin_section.button')}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AuthHome;